import QuotationAmounts from './QuotationAmounts';

/**
 * Class representing initial quotation amounts.
 */
class InitalQuotationAmounts extends QuotationAmounts {
  /**
   * Populate the instance with amounts from a preinvoice.
   * @param {Object} preinvoice - The preinvoice object.
   * @param {Array} preinvoice.services - The array of services in the preinvoice.
   * @param {number} preinvoice.services[].subtotal - The subtotal amount.
   * @param {number} preinvoice.services[].taxesAmount - The taxes amount.
   * @param {number} preinvoice.services[].total - The total amount.
   * @returns {InitalQuotationAmounts} The instance with populated amounts.
   */
  fromPreinvoice(preinvoice) {
    const { subtotal, taxesAmount, total } = preinvoice.services[0];

    this.subtotal = subtotal.toFixed(2);
    this.taxes = taxesAmount.toFixed(2);
    this.total = total.toFixed(2);

    return this;
  }
}

export default InitalQuotationAmounts;
